module.exports = __webpack_public_path__ + "static/media/delivery-truck-icon.f180b2bf.svg";